export const SpendCategories = [
    "Judgments Against the School District",
    "Mileage Reimbursement",
    "Parent Refund - Tuition",
    "Parent Refunds",
    "Participation Fee Refund",
    "Settlements Against the School District",
    "Student Transportation Purchased from Parents Expense",
    "Transportation Fees Refund"
];
